import { type RouteRecordRaw } from 'vue-router'

export const shopRoutes: RouteRecordRaw[] = [
  {
    path: '/shop',
    component: () => import('layouts/receiver/MainLayout.vue'),
    children: [
      {
        path: 'checkout',
        component: () =>
          import('pages/receiver/shop/checkout/CheckoutPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'payment-validation',
        component: () =>
          import('pages/receiver/shop/checkout/PaymentValidation.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'features/:permissionName',
        name: 'permissions-shop',
        component: () => import('pages/receiver/shop/CtaShop.vue'),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'limitations/:limitationName/:neededValue',
        name: 'limitations-shop',
        component: () => import('pages/receiver/shop/CtaShop.vue'),
        meta: {
          requiresAuth: false,
        },
      },
    ],
  },
  {
    path: '/pricing',
    component: () => import('layouts/receiver/MainLayout.vue'),
    children: [
      {
        path: 'plans',
        name: 'plans-page',
        component: () => import('pages/receiver/shop/PlanPage.vue'),
        meta: {
          requiresAuth: true,
          fluid: 'container-lg',
        },
      },
    ],
  },
]
